import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState, storeActions } from '../../../store'

import { AnimationSize } from '../../../models/enums'

import { ArrowLeftIcon, ArrowRightIcon } from '../../Icons/ArrowIcons'
import Animation from '../../Loader/Animation'

interface BorderlessButtonMessageProps {
  text: string
  differentTextTosend?: string
}

const BorderlessButtonMessage = ({ text, differentTextTosend }: BorderlessButtonMessageProps): JSX.Element => {
  const dispatch = useDispatch()
  const isRTL = useSelector((state: RootState) => state.localeReducer.isRTL)
  const themeColors = useSelector((state: RootState) => state.viewReducer.themeColors)
  const unlockClickedButton = useSelector((state: RootState) => state.utilsReducer.unlockClickedButton)

  const [hover, setHover] = useState<boolean>(false)
  const [clicked, setClicked] = useState<boolean>(false)

  const animationColor = {
    '--rf-color-loader-animation': themeColors.card.button.text.default
  } as React.CSSProperties

  const onClick = (text: string): void => {
    setClicked(true)
    dispatch(storeActions.utils.lockClickedButton())
    dispatch(storeActions.directline.sendMessage({ text: text }))
  }

  useEffect(() => {
    unlockClickedButton && setClicked(false)
  }, [unlockClickedButton])

  return (
    <div className='rf-w-full rf-flex rf-justify-start rf-cursor-pointer'>
      <div
        className='rf-w-full rf-flex rf-flex-row rf-items-center rf-justify-start rf-text-cardButtonTextDefault'
        onPointerEnter={(): void => setHover(true)}
        onPointerLeave={(): void => setHover(false)}
        onClick={(): void => {
          setHover(true)
          onClick(differentTextTosend || text)
        }}
      >
        {clicked ? (
          <div
            className='rf-h-6 rf-w-6 rf-flex rf-justify-center rf-items-center'
            style={{
              ...animationColor
            }}
          >
            <div className='rf-w-2 rf-h-2'>
              <Animation size={AnimationSize.small} />
            </div>
          </div>
        ) : (
          <div className={`rf-h-6 rf-w-6 rf-rounded ${hover ? 'rf-bg-cardButtonBackgroundHover' : 'rf-bg-cardButtonBackgroundDefault'}`}>
            {isRTL ? (
              <ArrowLeftIcon
                className='rf-h-6 rf-p-1 rf-border rf-rounded rf-border-cardButtonBorderDefault'
                color={hover ? themeColors.card.button.text.hover : themeColors.card.button.text.default}
              />
            ) : (
              <ArrowRightIcon
                className='rf-h-6 rf-p-1 rf-border rf-rounded rf-border-cardButtonBorderDefault'
                color={hover ? themeColors.card.button.text.hover : themeColors.card.button.text.default}
              />
            )}
          </div>
        )}
        <div className={`${isRTL ? 'rf-mr-4' : 'rf-ml-4'}`}>{text || ''}</div>
      </div>
    </div>
  )
}

export default BorderlessButtonMessage
